import { useState } from "react";

import { useWindowDimensions } from "@luce/core";
import { AdaptiveModal, Box, Button, Image, TextField, Typography } from "@luce/ui";

import envelope from "../assets/envelope.png";
import { useRedeemModal } from "./use-redeem-modal";

export interface RedeemGiftCardModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialCode?: string;
}

export function RedeemGiftCardModal({ open, onOpenChange, initialCode }: RedeemGiftCardModalProps) {
  const { isDesktop } = useWindowDimensions();
  const [code, setCode] = useState(initialCode ?? "");
  const { redeem, loading } = useRedeemModal({
    onRedeemed: () => {
      setCode("");
      onOpenChange(false);
    },
  });

  const [prevInitialCode, setPrevInitialCode] = useState(initialCode);
  if (initialCode !== prevInitialCode) {
    setPrevInitialCode(initialCode);
    if (initialCode) setCode(initialCode);
  }

  return (
    <AdaptiveModal.Root
      open={open}
      onOpenChange={onOpenChange}
      dismissible={!loading}
      dialogSize="sm"
    >
      <AdaptiveModal.Header>
        <Box className="gap-spacing-md flex flex-row items-center">
          <Image src={envelope} alt="" width={28} height={28} />
          <AdaptiveModal.Title className="flex-1">Redeem your gift card</AdaptiveModal.Title>
          {isDesktop && (
            // Not while the card is being redeemed
            <AdaptiveModal.Close disabled={loading} />
          )}
        </Box>
        <AdaptiveModal.Description>
          Enter the code to preview who it’s from and the message inside.
        </AdaptiveModal.Description>
      </AdaptiveModal.Header>

      <AdaptiveModal.Body>
        <Box className="gap-spacing-xxs flex flex-col">
          <Typography variant="label-sm">Gift card code</Typography>
          <TextField
            size="md"
            placeholder="Enter gift card code"
            value={code}
            onChangeText={setCode}
            disabled={loading}
          />
        </Box>
      </AdaptiveModal.Body>

      <AdaptiveModal.Footer>
        <Button
          variant="primary"
          size="lg"
          fullWidth
          label="Redeem"
          loading={loading}
          onClick={() => redeem(code)}
        />
      </AdaptiveModal.Footer>
    </AdaptiveModal.Root>
  );
}
